var TOAST_DURATION = 3000;
export var createSettingsToasts = function (toast, t) {
    var showSuccessToast = function (descriptionKey) {
        return toast({
            title: t('alert.success'),
            description: descriptionKey
                ? t(descriptionKey)
                : t('generalSettings.settingsSaved'),
            variant: 'success',
            duration: TOAST_DURATION
        });
    };
    var showErrorToast = function (descriptionKey) {
        return toast({
            title: t('alert.error'),
            description: descriptionKey
                ? t(descriptionKey)
                : t('generalSettings.settingsFailed'),
            variant: 'error',
            duration: TOAST_DURATION
        });
    };
    var showStatusUpdatedToast = function () {
        return toast({
            title: t('usersSection.statusUpdated'),
            description: t('generalSettings.settingsSaved'),
            variant: 'success',
            duration: TOAST_DURATION
        });
    };
    return {
        showSuccessToast: showSuccessToast,
        showErrorToast: showErrorToast,
        showStatusUpdatedToast: showStatusUpdatedToast
    };
};
